import React from 'react';
import { format } from 'date-fns';
import Box from '../Box';

function DateCell(_ref) {
  var date = _ref.date,
      showTime = _ref.showTime;
  return /*#__PURE__*/React.createElement(Box, null, format(date, showTime ? 'MMM dd, yyyy h:mm:A' : 'MMM dd, yyyy'));
}

export default DateCell;